import { GridConditionsEAP2Widget } from './gridConditionsEAP2';
import { FuelMixWidget } from './fuelmix';
import { CsatSupplyDemandWidget } from './csatSupplyDemand';

const Widgets = {
	GridConditionsEAP2Widget: GridConditionsEAP2Widget,
	FuelMixWidget: FuelMixWidget,
	CsatSupplyDemandWidget: CsatSupplyDemandWidget
};

// Expose Widgets globally for browser usage
(window as any).Widgets = Widgets;

export { Widgets };